import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "next-themes";
import ThemeInitializer from "@/components/ThemeInitializer";
import { AppProvider } from "@/context/AppContext";
import { ConfigProvider } from "@/context/ConfigContext";
import { ConfigLoader } from "@/components/ConfigLoader";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import InfoPanelExpanded from "./pages/InfoPanelExpanded";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <ConfigProvider>
      <ConfigLoader>
    <ThemeProvider attribute="class" defaultTheme="light" enableSystem>
      <ThemeInitializer />
      <AppProvider>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <BrowserRouter>
            <Routes>
              <Route path="/info-panel-expanded" element={<InfoPanelExpanded />} />
                  <Route path="/*" element={<Index />} />
              {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
        </TooltipProvider>
      </AppProvider>
    </ThemeProvider>
      </ConfigLoader>
    </ConfigProvider>
  </QueryClientProvider>
);

export default App;
